import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import GasIcon from '@/assets/gas-icon';
import LeftCard from '@/views/home_view/components/left-card/LeftCard';

import useConfigStore from '@/store/configStore';
import useAppStore from '@/store/app.store';

import { appRoutes } from '@/config/appRoutes';
import { COMPANY_TYPE } from '@/constants/company-type';
import { ROLES } from '@/constants/roles';

export default function ConsumerCard() {
  const navigate = useNavigate();
  const environmentSettings = useConfigStore((state) => state.environmentSettings);
  const user = useAppStore((state) => state.user);

  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    navigate(`${environmentSettings?.BASE_PATH ?? ''}${appRoutes.CONSUMER}`);
  }, [navigate, environmentSettings]);

  const disabled = useMemo(
    () =>
      user?.companies?.[0]?.company?.companyType?.code !== COMPANY_TYPE.CONSUMER && user?.role !== ROLES.MOEVE_ADMIN,
    [user]
  );

  return (
    <LeftCard
      title={t('home.consumerCard.title')}
      description={t('home.consumerCard.description')}
      backgroundColor="#2196F3"
      textColor="#FFFFFF"
      iconColor="var(--palette-white)"
      Icon={GasIcon}
      disabled={disabled}
      onClick={handleClick}
    />
  );
}
